<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyWork"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <div id="maoli">
      <div class="block">
        <h4>汇总统计</h4>
        <ul>
          <li v-for="(x, index) in sum" :key="index">
            <h3>{{ x }}</h3>
            <p>{{ type[index] }}</p>
          </li>
        </ul>
      </div>
      <div class="block">
        <h4>毛利分析明细表</h4>
        <Table
          border
          :columns="listReceivableCol"
          :data="listReceivable"
          no-data-text="<div class='table-no-data'></div>"
          :height="500"
        >
        </Table>
      </div>
    </div>
  </div>
</template>
<script>
var kehuitems = [];

export default {
  data() {
    return {
      listReceivableCol: [
        {
          title: "订单号",
          key: "ono",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "币别",
          key: "currency",
        },
        {
          title: "应收金额",
          key: "money",
        },
        {
          title: "应付金额",
          key: "payableMoney",
        },
        {
          title: "已收金额",
          key: "moneyReal",
        },
        {
          title: "已付金额",
          key: "payableMoneyReal",
        },
        {
          title: "毛利润",
          key: "grossProfit",
        },
        {
          title: "毛利率/%",
          key: "grossProfitRate",
        },
        {
          title: "业务员",
          key: "saleman",
        },
        {
          title: "备注信息",
          key: "remark",
        },
        {
          title: "操作员",
          key: "creator",
          sort: 200,
        },
        {
          title: "操作时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
      ],
      listReceivable: [],
      listPayableCol: [
        {
          title: "订单号",
          key: "ono",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "币别",
          key: "currency",
        },
        {
          title: "应付金额",
          key: "money",
        },
        {
          title: "已付金额",
          key: "moneyReal",
        },
        {
          title: "业务员",
          key: "saleman",
        },
        {
          title: "备注信息",
          key: "remark",
        },
        {
          title: "操作员",
          key: "creator",
          sort: 200,
        },
        {
          title: "操作时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
      ],
      listPayable: [],
      sum: {
        totalAmountPayable: 0,
        totalAmountReceivable: 0,
        totalAmountReceivableReal: 0,
        totalAmountPayableReal: 0,
        grossProfit: 0,
        grossProfitRate: 0,
      },
      forms: [],
      searchItem: {
        startTime: "",
        endTime: "",
        cid: "",
        ono: "",
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "客户",
          key: "cid",
          selectItems: kehuitems,
          type: "Select",
          selectType: "obj",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
      ],
      type: {
        totalAmountPayable: "应付总金额",
        totalAmountReceivable: "应收总金额",
        totalAmountReceivableReal: "已收总金额",
        totalAmountPayableReal: "已付总金额",
        grossProfit: "毛利润",
        grossProfitRate: "毛利率(100%)",
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/profitAnalyse",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data;

        this.listReceivable =
          data.listReceivable == null ? [] : data.listReceivable;
        // this.listPayable = data.listPayable;

        for (const i in this.sum) {
          this.sum[i] = data[i];
        }

        console.log("表格数据", this.listReceivable);
      });
    },

    search() {
      this.getList();
    },

    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
  },
  mounted() {
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
  },
};
</script>
<style>
#maoli {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
  background: #f5f5f5;
}
#maoli .block {
  padding: 15px;
  background: #fff;
  margin: 4px 0;
}
#maoli .block h4 {
  margin-bottom: 20px;
}
#maoli .block ul {
  display: flex;
  margin-bottom: 10px;
}
#maoli .block ul li {
  flex: 1;
  text-align: center;
}
#maoli .block ul li h3 {
  font-weight: bold;
  font-size: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/maolifenxi.vue